/** Local CRM data is keyed by the account and the space: two accounts on one browser never read each other's. */
export const CRM_STORAGE_PREFIX = 'tendbble.crm.v3.';
/** The key older builds wrote, by space only: the personal CRMs of every account on the browser shared it. */
export const CRM_LEGACY_PREFIX = 'tendbble.crm.v2.';
/** What the import remembers of a table's shape: the mapping chosen for it last time, per account and space. */
export const CRM_IMPORT_PREFIX = 'tendbble.crm.import.v1.';

/**
 * Every account's CRM data on this browser, old keys included: a sign-out leaves none behind. Kept apart from the
 * store so the shell can call it without loading the CRM.
 */
export function forgetAllLocalCrm(
    storage: Pick<Storage, 'length' | 'key' | 'removeItem'> | undefined = globalThis.localStorage,
): void {
    if (!storage) {
        return;
    }
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i += 1) {
        const key = storage.key(i);
        if (
            key &&
            [CRM_STORAGE_PREFIX, CRM_LEGACY_PREFIX, CRM_IMPORT_PREFIX].some((prefix) => key.startsWith(prefix))
        ) {
            keys.push(key);
        }
    }
    for (const key of keys) {
        storage.removeItem(key);
    }
}
